/**
 * `SubjectProperty.feasibilityReportStatus` — the stage of the third-party
 * feasibility / construction-inspection report for one property.
 *
 * Values are VERBATIM from `subject_property` in the LOS model
 * (`app/models/pipeline.py`, general-contractor-docs.md §3). This list is the
 * "schema hasn't loaded yet" fallback for
 * `useModelFieldOptions("feasibilityReportStatus", …, { objectType: "subjectProperty" })`
 * — never add a value here that the model does not have.
 *
 * Whether a report is REQUIRED is a separate, computed signal
 * (`feasibility_required` on the property: budget > $150k, change of use,
 * expansion, budget > purchase price). This field says only whether one has
 * been ordered / received / reviewed, and it is what the budget-review
 * feasibility rollup reads for its `ordered` flag.
 */
export const selectOptionsFeasibilityReportStatus = [
  "Not Ordered",
  "Ordered",
  "Received",
  "Reviewed",
];

/** Statuses that mean "someone has actually ordered one". */
export const FEASIBILITY_ORDERED_STATUSES = ["Ordered", "Received", "Reviewed"];

export default selectOptionsFeasibilityReportStatus;
